<template>
  <footer>
    <div id="container">
      <div class="footer_top">
        <div style="display: flex">
          <div style="margin-right: 50px">
            <img
              src="../assets/img/footlogo.png"
              style="width: 150px; height: 90px; margin-top: -20px"
            />
          </div>
          <div style="font-size: 14px; line-height: 14px">
            <div>
              {{ $t("footer.phone") }}:010-89683011（{{
                $t("footer.monday")
              }}9：00-17：00）
            </div>
            <div style="margin: 10px 0">
              {{ $t("footer.email") }}：youerduoyujiaoyu@163.com
            </div>
            <div>{{ $t("footer.address") }}</div>

            <div style="margin-top: 30px">
              {{ $t("footer.add1") }}
            </div>
            <div style="margin: 10px 0">
              {{ $t("footer.add3") }}
            </div>
            <div>
              {{ $t("footer.add2") }}
            </div>
          </div>
        </div>

        <div class="introduce">
          <div style="margin-right: 50px">
            <div class="bigsize" @click="go(1)">{{ $t("footer.serve") }}</div>
            <div class="size margin" @click="go(2)">
              {{ $t("footer.agreement") }}
            </div>
          </div>
          <div>
            <div class="bigsize" @click="go(3)">{{ $t("footer.help") }}</div>
            <div class="size margin" @click="go(4)">
              {{ $t("footer.concat") }}
            </div>
            <!-- <div class="size" @click="go(4)">用户反馈</div> -->
          </div>
        </div>
      </div>

      <div class="footer_bot">
        <!-- <div style="margin-bottom: 14px">
          <a target="_blank" class="beijing" href="http://www.mbxq.org.cn">{{
            $t("footer.danwei")
          }}</a>
          <a target="_blank" class="beijing" href="http://www.cycc.org.cn/">{{
            $t("footer.china")
          }}</a>
          {{ $t("footer.create") }}
        </div> -->

        <div style="margin-bottom: 14px">
          友情链接:
          <a target="_blank" class="beijing">
            中国关心下一代工作委员会健体中心
          </a>
          <a target="_blank" class="beijing">
            中国民办教育协会学前教育专业委员会
          </a>
          <a target="_blank" class="beijing">
            中国成人教育协会培训工作委员会
          </a>
          <a target="_blank" class="beijing"> 中国管理科学研究院学术委员会 </a>
          <a target="_blank" class="beijing"> 北京联合国教科文组织协会 </a>
        </div>
        <a class="hre" target="_blank">
          {{ $t("footer.code") }}
          <!--  <a target="_blank" href="http://beian.miit.gov.cn/" class="beijing">京ICP备19000971号-1</a>&nbsp;
                    京公网安备31010702004489号 -->
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footer",
  data() {
    return {};
  },
  methods: {
    go(params) {
      console.log(params, "jiajaiajia");
      if (params === 1) {
        //用户协议
        window.open(
          `https://view.officeapps.live.com/op/view.aspx?src=https://multilingual-education.oss-cn-beijing.aliyuncs.com/homeFile/freeText.doc`
        );
      } else if (params === 2) {
        //免责声明
        window.open(
          `https://view.officeapps.live.com/op/view.aspx?src=https://multilingual-education.oss-cn-beijing.aliyuncs.com/homeFile/userText.docx`
        );
      } else if (params === 3) {
        this.$router.push({
          name: "aboutUs",
          params: {
            id: 4,
          },
        });
      } else if (params === 4) {
        this.$router.push({
          name: "aboutUs",
          params: {
            id: 3,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.beijing {
  display: inline;
  color: rgba(255, 255, 255, 0.6);

  &:hover {
    color: #fff;
  }
}

.bigsize {
  font-size: 14px;
  margin-bottom: 10px;

  &:hover {
    color: #0093dd;
  }
}

.size {
  font-size: 12px;

  &:hover {
    color: #0093dd;
    cursor: pointer;
  }
}

.margin {
  margin: 4px 0;
}

footer {
  background-color: #4e565b;
  width: 100%;
}

#container {
  z-index: 1001;
  box-sizing: border-box;
  color: #fff;
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0 14px 0;

  .footer_top {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 100px 40px 100px;

    .introduce {
      display: flex;
      text-align: center;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .footer_bot {
    border-top: 1px solid rgba(255, 255, 255, 0.5);
    font-size: 12px;
    text-align: center;
    padding: 10px 0px 0 0px;
    margin-top: 10px;
    color: rgba(255, 255, 255, 0.6);

    .hre {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue